import type { ApplyOnboardingTemplatesBodyRolesItem } from "@/api";

export const SUB_ROLES_BY_PARENT = {
  researcher: [
    "researcher_math",
    "researcher_physics",
    "researcher_computer_science",
    "researcher_other",
  ],
  engineer: ["engineer_software", "engineer_mechanical", "engineer_electrical", "engineer_other"],
  student: ["student_college", "student_high_school", "student_middle_school"],
  educator: ["educator_college", "educator_high_school", "educator_middle_school"],
} as const satisfies Partial<Record<ApplyOnboardingTemplatesBodyRolesItem, readonly string[]>>;

export type ParentRoleWithDetail = keyof typeof SUB_ROLES_BY_PARENT;
export type SubRole = (typeof SUB_ROLES_BY_PARENT)[ParentRoleWithDetail][number];

export const hasSubRoles = (role: string | null | undefined): role is ParentRoleWithDetail =>
  role != null && role in SUB_ROLES_BY_PARENT;

export const isOtherSubRole = (sub: SubRole): boolean => sub.endsWith("_other");
